import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useMetricTileStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    padding: tokens.spacingVerticalL,
    borderRadius: tokens.borderRadiusLarge,
    backgroundColor: tokens.colorNeutralBackground1,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    minWidth: '12rem',
  },
  label: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    margin: 0,
  },
  values: {
    display: 'flex',
    alignItems: 'baseline',
    gap: tokens.spacingHorizontalL,
  },
  valueGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
  },
  valueCaption: {
    fontSize: fontScale.caption,
    color: tokens.colorNeutralForeground3,
  },
  value: {
    fontSize: fontScale.subtitle,
    fontWeight: tokens.fontWeightBold,
    color: tokens.colorNeutralForeground1,
    lineHeight: tokens.lineHeightBase400,
  },
  completedValue: {
    color: tokens.colorBrandForeground1,
  },
  barTrack: {
    position: 'relative',
    height: '0.5rem',
    borderRadius: tokens.borderRadiusCircular,
    backgroundColor: tokens.colorNeutralBackground4,
    overflow: 'hidden',
  },
  barFill: {
    position: 'absolute',
    insetBlockStart: 0,
    insetInlineStart: 0,
    height: '100%',
    borderRadius: tokens.borderRadiusCircular,
    backgroundColor: tokens.colorBrandBackground,
  },
});
